import { configure, getConfiguration } from 'redux-and-the-rest';

/**
 * Configure redux-and-the-rest globally with an authentication token
 * @param {string} authenticationToken The new authentication token to be used for all requests, or undefined to clear
 */
export default function configureRequestAuthToken(authenticationToken?: string): void {
  const authorization = authenticationToken ? `Token token="${authenticationToken}"` : undefined;

  configure({
    request: {
      ...getConfiguration().request,
      headers: {
        Authorization: authorization,
      },
    },
  });
}
